/**
 * Returns the values of an object as an array sorted by the provided attribute.
 *
 * @example
 * moveObjToSortedArray({ one: { score: 1 }, two: { score: 2 }, three: { score: 3 } }, "score");
 * // returns [{ score: 3 }, { score: 2 }, { score: 1 }]
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
export function moveObjToSortedArray(obj: any, sortByKey: string): any[] {
  const tempArray = [];
  for (const key in obj) {
    tempArray.push(obj[key]);
  }
  tempArray.sort((a, b) => b[sortByKey] - a[sortByKey]);
  return tempArray;
}
